import { ElementType, useEffect, useState, useCallback } from 'react';
import cn from 'classnames';
import { isScreenS } from '@dealroadshow/uikit-styles/screen/screen';
import { useHeaderMenuContext } from '@/creditflowresearch/application/SearchHeaderMenu/HeaderMenuContext';
import Logo from '../Header/Logo';
import Links, { ILinkConfig } from '../Header/Links';
import IconClose from '@dealroadshow/uikit-icon/IconClose';
import IconHamburgerMenu from '@dealroadshow/uikit-icon/IconHamburgerMenu';
import styles from '@/finsight/ui/common/components/header/Header/header.module.scss';

interface IProps {
  transparent?: boolean,
  LogoComponent?: ElementType<{ onClick: () => void }>,
  linksConfig?: ILinkConfig[],
}

const FinsightHeader = ({
  transparent = false,
  LogoComponent = Logo,
  linksConfig,
}: IProps) => {
  const { isMobileMenuOpen, isSearchResultsOpen, setIsMobileMenuOpen } =
    useHeaderMenuContext();
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  useEffect(() => {
    const updateScreen = () => setIsSmallScreen(isScreenS());
    updateScreen();
    window.addEventListener('resize', updateScreen);
    return () => window.removeEventListener('resize', updateScreen);
  }, []);

  const toggleMobileMenu = useCallback(() => {
    if (!isMobileMenuOpen) window.dispatchEvent(new Event('resize'));
    setIsMobileMenuOpen((prev) => !prev);
  }, [isMobileMenuOpen, setIsMobileMenuOpen]);

  const closeMenu = useCallback(() => {
    if (isMobileMenuOpen) setIsMobileMenuOpen(false);
  }, [isMobileMenuOpen, setIsMobileMenuOpen]);

  const IconComponent = isMobileMenuOpen ? IconClose : IconHamburgerMenu;

  const containerClass = cn(styles.headerContainer, {
    [styles.transparentBackground]: transparent,
    [styles.searchResultOpenedOnMobileView]: isSearchResultsOpen,
    [styles.menuOpenedOnMobileView]: isMobileMenuOpen,
    [styles.hideSearchOnMobileView]: !isMobileMenuOpen,
  });

  return (
    <div className={ containerClass }>
      <div className={ styles.headerContent }>
        <div
          className={ cn(styles.headerTopRow, {
            [styles.headerScroll]: isMobileMenuOpen,
          }) }
        >
          <LogoComponent onClick={ closeMenu } />
          <IconComponent
            className={ styles.burgerButton }
            onClick={ toggleMobileMenu }
            data-test="mobileMenuBurgerButton"
          />
          { !(isSearchResultsOpen && isSmallScreen) && (
            <div
              className={ cn(
                styles.linksButtonsContainer,
                styles.premiumizationLinksContainer,
              ) }
            >
              <Links
                linksConfig={ linksConfig }
                wrapperClassName={ styles.withoutLogin }
                callbackItemClick={ closeMenu }
              />
            </div>
          ) }
        </div>
      </div>
    </div>
  );
};

export default FinsightHeader;
